import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useAppContext } from "Main";
import { BsGrid3X3Gap, BsGrid3X3GapFill } from "react-icons/bs";

const renderTooltip = (props) => (
  <Tooltip style={{ position: "fixed" }} id="button-tooltip" {...props}>
    Toggle Navigation
  </Tooltip>
);

const ToggleButton = () => {
  const {
    config: { isNavbarVerticalCollapsed, isFluid, isRTL },
    setConfig,
  } = useAppContext();

  const handleClick = () => {
    document
      .getElementsByTagName("html")[0]
      .classList.toggle("navbar-vertical-collapsed");
    setConfig("isNavbarVerticalCollapsed", !isNavbarVerticalCollapsed);
  };

  return (
    <OverlayTrigger
      placement={
        isFluid ? (isRTL ? "bottom" : "right") : isRTL ? "bottom" : "left"
      }
      overlay={renderTooltip}
    >
      <div className="toggle-icon-wrapper" style={{ marginRight: 0 }}>
        <Button
          variant="link"
          className="navbar-toggler-humburger-icon navbar-vertical-toggle"
          id="toggleNavigationTooltip"
          onClick={handleClick}
          style={{ fontSize: "24px" }}
        >
          <BsGrid3X3GapFill />
          {/* <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span> */}
        </Button>
      </div>
    </OverlayTrigger>
  );
};

export default ToggleButton;
